// CONTENT
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const LOAD_CONTENT = 'LOAD_CONTENT';

// TEAM PAGE AND LIST OF TEAMS
export const REQUEST_TEAMS_LIST = 'REQUEST_TEAMS_LIST';
export const FILTER_TEAMS = 'FILTER_TEAMS';
